export enum TaxIdType {
  Thai = 'thai',
  Foreign = 'foreign',
}

export enum BranchType {
  Headquarter = 'headquarter',
  Branch = 'branch',
  Unspecified = 'unspecified',
}

export interface CompanyTaxInvoiceFormValues {
  tax_id_type: TaxIdType
  branch_type: BranchType
  branch_name?: string
  sub_district: string
  district: string
  province: string
  zip_code: string
  email: string
  phone: string
}
